import React from 'react'

// Define an interface for the component's props
interface PlayerNameCardProps {
  title?: any
  rank?: any
  leagueMatchId?: any
  winner?: any
  bye?: any
  onClick: () => void
}

const PlayerNameCard: React.FC<PlayerNameCardProps> = ({ title, rank, leagueMatchId, winner, bye, onClick }) => {
  return (
    <div
      className={`w-full h-full cursor-pointer flex border-[2px] rounded-[2px] ${
        winner ? 'bg-primary' : bye ? 'bg-slate-300' : ''
      }`}
      onClick={() => {
        onClick()
      }}
    >
      <h5 className={`${winner || bye ? 'text-white' : ''} w-full text-sm font-medium truncate pl-2 py-2`}>
        {title}
        &nbsp;
        {/* use for diagnosing purpose only */}
        {false && leagueMatchId}
      </h5>
      {rank !== 0 && (
        <h5
          className={`${
            winner ? 'bg-primary-700 text-white' : 'bg-[#eaf3fe]'
          } w-9 text-center text-sm font-medium flex items-center justify-center`}
        >
          {rank}
        </h5>
      )}
    </div>
  )
}

export default PlayerNameCard
